import { Clip } from '../clip';
import { ScriptLayerClip as ScriptLayerClipClass } from './script';

export { ScriptLayerClip } from './script';
export type { 
    ScriptLayerClipProps, 
    ScriptLayerVideoSource,
    ScriptLayerInputConfig,
    ScriptLayerCut,
    ScriptLayerSplit,
    ScriptLayerSegment,
    ScriptLayerGap,
    ScriptLayerGapInsertion,
    SpeakerOverride,
    SpeakerMuteRange,
    TransitionConfig,
    AudioTransitionType,
    VideoTransitionType,
} from './script.interfaces';
export { DEFAULT_CUT_TRANSITION, DEFAULT_SPLIT_TRANSITION } from './script.interfaces';

// Type guard for ScriptLayerClip

export function isScriptClip(clip: Clip | null | undefined): clip is ScriptLayerClipClass {
    return clip instanceof ScriptLayerClipClass;
}
